import { Model, attr } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class PalIfpEnrolledOps extends Model {
  static get modelName() {
    return 'PalIfpEnrolledOps';
  }

  static options = { idAttribute: 'operationId' };

  static reducer({ type, data }, PalIfpEnrolledOps) {
    switch (type) {
      case LOAD_OPERATIONS.SUCCESS:
        if (!data?.props?.append) {
          PalIfpEnrolledOps.delete();
        }
        // API returns { operations: [...], nextToken } wrapped structure
        if (data?.response?.operations) {
          data.response.operations.forEach((op) =>
            PalIfpEnrolledOps.upsert(op)
          );
        } else if (Array.isArray(data?.response)) {
          data.response.forEach((op) => PalIfpEnrolledOps.upsert(op));
        } else if (data?.response) {
          PalIfpEnrolledOps.upsert(data.response);
        }
        break;

      case LOAD_OPERATION_DETAIL.SUCCESS:
        if (data?.response) {
          PalIfpEnrolledOps.upsert(data.response);
        }
        break;

      case LOAD_OPERATIONS.FAILURE:
        PalIfpEnrolledOps.delete();
        break;

      default:
        break;
    }
  }

  static get fields() {
    return {
      operationId: attr(),
      fspId: attr(),
      batchId: attr(),
      operationType: attr(),
      status: attr(),
      desiredVersion: attr(),
      currentStep: attr(),
      startedAt: attr(),
      completedAt: attr(),
      steps: attr(),
    };
  }
}

const name = PalIfpEnrolledOps.modelName;

export const LOAD_OPERATIONS = createLoadConst(name);
export const LOAD_OPERATION_DETAIL = createLoadConst(`${name}Detail`);

export const loadOperations = createAction(LOAD_OPERATIONS);
export const loadOperationDetail = createAction(LOAD_OPERATION_DETAIL);
